/* 信息处理 */
import Vue from 'vue'
import axiosMethods from '../../axios/axios-methods'
import { Message } from 'element-ui'

const state = {
   // mqtt信息
   message: {},
   excelFormGetter: {},
   assignVoice: false, // 是否提示开关
   timer: null, // 轮询
   tips: false, // 新消息 供外部调用
};

const mutations = {
   muTips(state, data) {
      state.tips = data
   },
   muAssignVoice(state, data) {
      state.assignVoice = data
   },
   muExcelForm(state, data) {
      state.excelFormGetter = data
   },
   muMessage(state, message) {
      state.message = message;

      if (message && message.msg === 'EXCEL') {
         let data = message.data ? JSON.parse(message.data) : {}
         this.dispatch('acExcelForm', data)
         if (data.status === 'success') {
            window.open(window.configure.qiniuUrl + data.result)
            Vue.prototype.$mqtt.cancelTopic({
               tpc: data.topic,
               opt: {
                  qos: 1
               }
            });
         } else if (data.status === 'error') {
            Vue.prototype.$message.error('导出失败')
         }
      }
   }
};

const getters = {
   messageGetter: state => state.message,
   excelFormGetter: state => state.excelFormGetter // 全局的消息推送
};

const actions = {
   acMessage({ commit }, message) { // 新信息
      commit('muMessage', message)
   },
   acExcelForm({ commit }, params) { // 添加 MQTT 订阅
      commit('muExcelForm', params)
   },
   async acAssignVoice({ commit, rootState }) { // 待指派订单提醒
      if (!rootState.login.userInfoGetter || rootState.login.permissions.indexOf('24') < 0) {
         commit('muAssignVoice', false) // 未登录
         return;
      }
      // 待指派提示开关
      let url = "/api/v1/manage/systems";
      let data = await axiosMethods.getAxios(url);
      if (data.code === 1) {
         commit('muAssignVoice', data.data.assignVoice == 1)
      }

      // 获取提示
      let getIsAssignOrder = async () => {
         if (state.timer && !state.assignVoice) {
            clearInterval(state.timer)
            return;
         }
         let url = "/api/v1/manage/order/isAssignOrder";
         let data = await axiosMethods.getAxios(url);
         if (data.code === 1 && data.data) {
            Message({
               message: '有待指派订单，请及时处理',
               type: 'warning'
            })
            let tipsMp3 = require('../../assets/mp3/tobeAssigned.mp3');
            tipsMp3 = new Audio(tipsMp3);
            tipsMp3.play();
            commit('muTips', true)
         }
      }

      if (state.assignVoice) {
         getIsAssignOrder();
         if (state.timer) {
            clearInterval(state.timer)
         }
         state.timer = setInterval(() => {
            getIsAssignOrder();
         }, 60000);
      }

   }
};

export default {
   // namespaced: true 使其成为带命名空间的模块  message/xxx
   name: 'message',
   state,
   mutations,
   getters,
   actions
}